import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const getAllBanks = createAsyncThunk('banks/getAllBanks', async (_, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/banks`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.data?.message || error.message);
  }
});

export const getDetailAccountBank = createAsyncThunk('banks/getDetailAccountBank', async (userId, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/account-bank/user/${userId}`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.data?.message || error.message);
  }
});

export const getAllCurrencies = createAsyncThunk('currency/getAllCurrencies', async (_, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/currencies`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.data?.message || error.message);
  }
});
